import React, { useRef } from "react"
import { FormikProps } from "formik"
import { useNavigate } from "react-router"
import { MERCHANT_ADMIN_SETTINGS_DELIVERY_LOCATIONS_ROUTE, MERCHANT_ADMIN_ROUTE } from "../../../../../constants/routes"
import { CreateUpdateDeliveryLocationForm } from "../components/CreateUpdateDeliveryLocationForm"
import { DeliveryLocationsQuery, createDeliveryLocation } from "../deliveryLocationsApi"
import { StandardButton } from "../../../../../shared/components/buttons/StandardButton"
import { PageHeader } from "../../../../../shared/components/pageHeader/PageHeader"
import { LocalizedStrict } from "../../../../localization/components/AppLocalized"
import { CreateOrEditDeliveryLocationFormValues } from "../deliveryLocationsTypes"
import { Page } from "../../../../../shared/components/pageHeader/PageHeaderApi"
import { useApiMutation } from "../../../../../core/api/useApiMutation"
import { SuccessDisplay } from "../../../../../core/api/errorTypes"
import { prepareInitialValues } from "../helpers/prepareInitialValues"
import {
    Breadcrumb,
    BreadcrumbLink,
    StandardBreadcrumbs,
} from "../../../../../shared/components/links/StandardBreadcrumbs"
import { useDateTime } from "../../../../localization/useDateTime"

export function CreateDeliveryLocation() {
    const navigate = useNavigate()
    const formRef = useRef<FormikProps<CreateOrEditDeliveryLocationFormValues>>(null)
    const dateTimeFactory = useDateTime()

    const handleSaveClick = () => {
        formRef.current?.submitForm()
    }

    const { mutate: callCreateDeliveryLocation } = useApiMutation(createDeliveryLocation, {
        successDisplay: SuccessDisplay.SNACKBAR,
        async onSuccess(_, __, context) {
            await context.queryClient.invalidateQueries({ queryKey: [DeliveryLocationsQuery.LIST] })
            navigate(MERCHANT_ADMIN_SETTINGS_DELIVERY_LOCATIONS_ROUTE)
        },
    })

    return (
        <>
            <LocalizedStrict id="merchant-delivery-location-create-header" attrs={{ title: true }}>
                <PageHeader
                    page={Page.MERCHANT_ADMIN_DELIVERY_LOCATION_CREATE}
                    title="Create delivery location"
                    rightElement={
                        <LocalizedStrict id="merchant-delivery-locations-create-button">
                            <StandardButton onClick={handleSaveClick}>Create</StandardButton>
                        </LocalizedStrict>
                    }
                >
                    <StandardBreadcrumbs>
                        <LocalizedStrict id="merchant-nav-item-home">
                            <BreadcrumbLink to={MERCHANT_ADMIN_ROUTE}>Home</BreadcrumbLink>
                        </LocalizedStrict>
                        <LocalizedStrict id="merchant-nav-item-settings-header">
                            <Breadcrumb>Settings</Breadcrumb>
                        </LocalizedStrict>
                        <LocalizedStrict id="merchant-nav-item-delivery-locations">
                            <BreadcrumbLink to={MERCHANT_ADMIN_SETTINGS_DELIVERY_LOCATIONS_ROUTE}>
                                Delivery locations
                            </BreadcrumbLink>
                        </LocalizedStrict>
                        <LocalizedStrict id="merchant-delivery-location-create-breadcrumb">
                            <Breadcrumb>Create delivery location</Breadcrumb>
                        </LocalizedStrict>
                    </StandardBreadcrumbs>
                </PageHeader>
            </LocalizedStrict>

            <CreateUpdateDeliveryLocationForm
                ref={formRef}
                initialValues={prepareInitialValues(dateTimeFactory)}
                onSubmit={callCreateDeliveryLocation}
            />
        </>
    )
}
